import React, { useEffect, useState } from "react";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import DatepickerIcons from "../../assets/images/datepickerIcons.png";
import { DatePicker, defaultDatePickerStrings, type IDatePicker } from "@fluentui/react";

function DatePickerComponent(props: any) {
  const { handleFieldChange, editable, title, id, value, errors, isMaxDate } = props;

  const [isIphone, setIsIphone] = useState(false);

  useEffect(() => {
    const { userAgent } = navigator;
    if (userAgent.includes("iPhone")) {
      setIsIphone(true);
    } else {
      setIsIphone(false);
    }
  }, []);

  const onChange = (id: any) => (date: any) => {
    if (date) {
      handleFieldChange(id, moment(date).format("MM/DD/YYYY"));
    }
  };

  const onChangeRaw = (id: any, value: any) => {
    if (!moment(value, "MM/DD/YYYY", true).isValid()) {
      handleFieldChange(id, value || "");
    } else {
      handleFieldChange(id, moment(value).format("MM/DD/YYYY"));
    }
  };

  const checkFormat = (e: any) => {
    const isValidDate = !isNaN(Date.parse(e?.target?.value));

    if (!isIphone) {
      if (!isValidDate) {
        handleFieldChange(id, e?.target?.value || "");
      } else {
        handleFieldChange(id, moment(e?.target?.value).format("MM/DD/YYYY"));
      }
    }
  };

  const datePickerRef = React.useRef<IDatePicker>(null);

  const formatDate = (date?: Date): string => {
    if (!date) return "";
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  };

  return (
    <div className="question_container mx-auto relative w-full" style={{ maxWidth: "300px" }}>
      <div className="question_inner_container text-start">
        <label
          className="input-label block ml-1 question_title"
          dangerouslySetInnerHTML={{ __html: title }}
          style={{
            fontSize: "14px",
            fontWeight: 400,
            color: "#6B7280",
          }}
        />
      </div>
      <div className="mt-1 relative customDatepicker">
        <DatePicker
          allowTextInput={!isIphone}
          ariaLabel="Select a date"
          className={isIphone ? "iPhonePicker" : ""}
          componentRef={datePickerRef}
          disabled={!editable}
          id={id}
          {...(value &&
            moment(value, "MM/DD/YYYY", true).isValid() && {
              value: new Date(value),
            })}
          formatDate={formatDate}
          maxDate={!isMaxDate && new Date()}
          onBlur={(event: any) => checkFormat(event)}
          onSelectDate={onChange(id)}
          strings={defaultDatePickerStrings}
          textField={{
            ...(value &&
              !moment(value, "MM/DD/YYYY", true).isValid() && {
                value: value,
              }),
            onChange: (event, newValue) => onChangeRaw(id, newValue),
          }}
        />

        <div
          className="absolute right-[24px] top-[20px] transform -translate-y-1/2"
          style={{ pointerEvents: "none" }}
        >
          <img alt="DatepickerIcons" src={DatepickerIcons} />
        </div>
      </div>

      {errors && errors[id] && (
        <p className="absolute left-0" style={{ color: "red" }}>
          {errors[id]}
        </p>
      )}
    </div>
  );
}

export default DatePickerComponent;
